import { ReactComponent as IconDataElement } from '@/assets/svgs/data-element-purple.svg'
import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg'
import { ReactComponent as IconSearch } from '@/assets/svgs/icon-search.svg'
import Button from '@/components/Button/index'
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import InputSuffixIcon from '@/components/InputSuffixIcon'
import useEclips from '@/hooks/use-eclips/index'
import { useParams } from '@/lib/router-dom/index'
import rem from '@/utils/rem'
import { useEffect, useState } from 'react'
import Search from '@/componentsDS/Search/index';
import { feature, features } from "@/utils/feature-verifier";


export default function AddDataElementModal({
	visible,
	receiver,
	dataElements,
	close,
	submit,
}) {
	const { eclipId } = useParams();

	const { addRemoveDataElements } = useEclips()

	const [search, setSearch] = useState('')
	const [data, setData] = useState(dataElements)
	const handleAddDataElementSubmit = async () => {
		close()
		await addRemoveDataElements(eclipId, 'ADD', data?.filter((e) => e.selected))
		submit()
	}

	const handleSelection = (dataElement) => {
		const newData = [...data]
		newData?.map((item) => {
			if (
				item.dataElementId === dataElement.dataElementId &&
				item.type === dataElement.type
			) {
				item.selected = !item.selected
			}
			return item
		})
		setData(newData)
	}

	useEffect(() => {
		const newData = [...data]
		newData?.map((item) => {
			item.selected = false
			return item
		})
		setData(newData)
	}, [search, visible])

	useEffect(() => {
		setData(dataElements)
	}, [dataElements])


	return (
		<Modal visible={visible} variant='medium'  close={close}>
			<CardConfigure>
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__icon'}>
										<IconDataElement />
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										Add Data Element
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<div className="add-data-element__receiver">
							<span className="add-data-element__receiver__title">
								Recepient
							</span>
							<span className="add-data-element__receiver__value">
								{receiver?.name || 'No receipient'}
							</span>
						</div>
						<div className="add-data-element__search">
							<Search
								value={search}
								placeholder="Search data element"
								onChange={(e) => setSearch(e?.target.value)}
								onCancel={() => setSearch('')}
							/>
						</div>
						<div>
							<div className="add-data-element__list-summary">
								<span>Total Available</span>
								<span>
									{String(dataElements?.length || 0).padStart(2, '0')}
								</span>
							</div>
						</div>
						<div className="add-data-element__list">
							{data?.length > 0 ? (
								data
									?.filter((item) =>
										item?.elementName?.toLowerCase()?.includes(search) || !search?.trim().length,
									)
									?.map((item, index) => (
										<div
											className={`add-data-element__list-item ${item?.selected ? 'selected' : ''
												}`}
											key={`att-${index}`}
											onClick={() => handleSelection(item)}
										>
											<div className="add-data-element__list-item__title">
												<input
													type="checkbox"
													name={item?.id}
													checked={item?.selected}
												/>
												<div className={'add-data-element__list-item-icon'}>
													<IconDataElement />
												</div>
												<span className="add-data-element__list-item__name trim">
													{item.elementName}
												</span>
											</div>
											<span className="add-data-element__list-item__status">
												{item.type === 'SEND' ? 'Sending' : 'Receiving'}
											</span>
										</div>
									))
							) : (
								<div className="add-data-element__no_items">
									No data element found
								</div>
							)}
						</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<Button ghost text="Close" submit={close} />
						<span style={{ width: rem(10), display: 'inline-block' }}></span>
						<Button
							text="Add"
							//   loading={loading}
							submit={handleAddDataElementSubmit}
						/>
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	)
}
